import { getFirebaseClient } from '../firebase/firebaseClient'
import { getCloudRunUrl } from '../config/playground'

export async function authedFetch(
  path: string,
  options: RequestInit = {},
): Promise<Response> {
  const client = await getFirebaseClient()
  const idToken = await client.getIdTokenOrThrow()
  const baseUrl = getCloudRunUrl()
  const url = `${baseUrl}${path}`

  const response = await fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`,
      ...(options.headers ?? {}),
    },
  })

  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`Request failed (${response.status}): ${errorText}`)
  }

  return response
}
